import axios from "axios";

import config from "../frontend.config.json";

const BACKEND_ORIGIN = config.BACKEND_ORIGIN;

const AuthAPI = {
  authUser: async (username, password) => {
    return await axios({
      method: "POST",
      url: `${BACKEND_ORIGIN}/api/auth`,
      data: { username, password },
    });
  },
};

export default AuthAPI;
